export const chipsBurned = {
	byEmployee: {
		tabTitle: "Chips burned by employee",
		filename: "chips-burned-employee",
		printTitle: "Chips burned by employee",
	},
	tabTitle: "Total chips burnd",
	title: "Total chips burned",
	fileName: "total-chips-burned",
	printTitle: "Total chips burned",
	table: {
		name: "Name",
		count: "Amount",
		unitValue: "Unit value",
		totalValue: "Total",
		product: "Product",
		unitCount: "Unit quantity",
		fracionalCount: "Fract. amount",
		unitaryValue: "Unitary value",
	},
};
